import Loading from '../../../components/Loading';
import useEditSubjectHelpAndSupport from './useEditSubjectHelpAndSupport';
import SubjectForm from '../components/SubjectForm';

export default function EditSubjectHelpAndSupport() {
    const {
        isLoading,
        handleSubmit,
        subject
    } = useEditSubjectHelpAndSupport();

    return (
        <Loading loading={isLoading} >
            <SubjectForm action='Editar' subject={subject} key={subject?.id} onSubmit={handleSubmit} />
        </Loading>
    )
}
